import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../intl/messages';
import { Form, FormField } from '../form';

export interface ContactMeFormValues {
  name: string;
  email: string;
  message: string;
}

const fields: FormField[] = [
  {
    type: 'text',
    name: 'name',
    label: <FormattedMessage {...messages.yourName} />,
  },
  {
    type: 'text',
    name: 'email',
    label: <FormattedMessage {...messages.yourEmail} />,
  },
  {
    type: 'textarea',
    name: 'message',
    label: <FormattedMessage {...messages.message} />,
  },
];

export const validate = (values: ContactMeFormValues) => {
  const errors: Partial<ContactMeFormValues> = {};
  if (!values.name) {
    errors.name = 'Name is required';
  }
  if (!values.message) {
    errors.message = 'Message is required';
  }
  return errors;
};

interface ContactMeFormProps {
  onSubmit: (values: ContactMeFormValues) => void;
  loading?: boolean;
}

export const ContactMeForm: React.FC<ContactMeFormProps> = ({
  onSubmit,
  loading,
}) => (
  <Form<ContactMeFormValues>
    onSubmit={onSubmit}
    fields={fields}
    validate={validate}
    submitLabel={<FormattedMessage {...messages.sendMessage} />}
    hideCancel
    loading={loading}
  />
);
